import { NgModule } from '@angular/core';
import { CanMatchFn, RouterModule, Routes, UrlSegment } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';

/**
 * Segmenti di primo livello che corrispondono a pagine reali.
 * La route `:uid` viene attivata solo se il primo segmento NON è tra questi.
 */
const KNOWN_PAGE_PATHS = new Set([
  'location', 'articoli', 'articolo', 'help', 'error',
  'eventi', 'espositore', 'espositori',
]);

export const uidCanMatch: CanMatchFn = (_route, segments: UrlSegment[]) => {
  if (!segments.length) return false;
  return !KNOWN_PAGE_PATHS.has(segments[0].path);
};

const routes: Routes = [
  {
    // Route con UID opzionale nel prefisso: /{uid}/...
    // Attivata solo se il primo segmento non è un percorso noto (guard uidCanMatch)
    path: ':uid',
    component: FullComponent,
    canMatch: [uidCanMatch],
    loadChildren: () =>
      import('../app/pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: '',
    component: FullComponent,
    loadChildren: () =>
      import('../app/pages/pages.module').then((m) => m.PagesModule),
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // Scroll to top on Route Change to prevent auto
      // scrolling on page change
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
